<template>
  <div class="failureAccess">
    <van-pull-refresh
      v-model="isLoading"
      @refresh="onRefresh"
    >
      <i class="iconfont icon-chenggong-icon topicon"></i>
      <p class="title">预授信成功</p>
      <!--如果有提现金额才显示，没有不显示-->
      <HavingMoneyShow v-if="this.$store.state.commonForms.bwAmount !== null" />
      <div class="box"></div>
      <Button
        :text="draw"
        :type="danger"
        class="nextStep"
        :click="goToNextPage"
      />
    </van-pull-refresh>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>

<script>
// @ is an alias to /src
import Button from '@/components/Button.vue';
import ServerBank from '@/components/ServerBank.vue';
import HavingMoneyShow from './components/HaveMoneyShow.vue';
import { checkStatus } from './mixin';

export default {
  name: 'WaitingEvaluate',
  components: {
    HavingMoneyShow,
    Button,
    ServerBank
  },
  data() {
    return {
      draw: '下一步',
      isLoading: false,
      danger: 'danger',
      plain: 'plain',
    };
  },
  mixins: [checkStatus],
  watch: {
    creditAmount: () => {

    },
  },
  methods: {
    goToNextPage() {
      this.$store.dispatch('otherPages/nextJumpPage');
    },
    onRefresh() {
      setTimeout(() => {
        this.$store.dispatch('commonForms/checkCurrentStatus', {
          getInfo: false,
        });
        this.isLoading = false;
      }, 500);
    },
  },
  beforeCreate() {
    document
      .querySelector('body')
      .setAttribute('style', 'background-color:#fff');
  },
  mounted() {
    this.$store.dispatch('commonForms/checkCurrentStatus', { getInfo: false });
  },

  beforeDestroy() {
    document.querySelector('body').removeAttribute('style');
  },
};
</script>
<style scoped>
.title {
  color: #1c2438;
  font-size: 17px;
  letter-spacing: 0;
  text-align: center;
}
.nextStep {
  margin-top: 30px;
  margin-bottom: 12px;
}
.warn {
  box-sizing: border-box;
  height: 44px;
  margin: 0;
  padding: 0;
  padding-right: 15px;
  padding-left: 15px;
  color: #f55646;
  font-size: 14px;
  line-height: 44px;
  letter-spacing: 0;
  text-align: left;
}
.shell {
  box-sizing: border-box;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
}
.list {
  height: 44px;
  margin: 0;
  padding: 0;
  color: #495060;
  font-size: 14px;
  line-height: 44px;
  letter-spacing: 0;
}
.fl {
  float: left;
}
.fr {
  float: right;
}
.topicon {
  display: block;
  padding-top: 103px;
  color: #ff6538;
  font-size: 60px;
}
.box {
  width: 100%;
  height: 200px;
}
</style>
